<div class="title-container">
  <div class="title semibold title--subtitle">{{ subtitle }}</div>
  <div class="reset-filter reset-filter--hidden" role="reset-filter">{{ __('filters.reset') }}</div>
</div>
